import React from 'react';
import { Popover } from '@mui/material';
import { CompactPicker } from 'react-color';

/**
 * A popover component that displays a color picker.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.open - Whether the popover is open or not.
 * @param {function} props.handleButtonClick - The event handler for the button click.
 * @param {string} props.color - The selected color.
 * @param {function} props.handleEvent - The event handler for color change.
 * @param {string} props.elementId - The ID of the element to anchor the popover to.
 * @returns {JSX.Element} The rendered ColorPickerPopover component.
 */
const ColorPickerPopover = ({ open, handleButtonClick, color, handleEvent, elementId }) => {
    return (
        <Popover
            open={open}
            onClose={handleButtonClick}
            anchorEl={document.getElementById(elementId)}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <CompactPicker color={color} onChangeComplete={handleEvent} />
        </Popover>
    );
};

export default ColorPickerPopover;
